var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CycleHeader',{attrs:{"image":_vm.image,"is-curved":""}},[(_vm.hasBadge)?_c('CycleHeaderPanel',_vm._b({},'CycleHeaderPanel',_vm.definedProps,false),[_c('ScPlaceholder',{attrs:{"name":"jss-content","rendering":_vm.rendering}})],1):_vm._e(),(_vm.alternative)?_c('ButtonsPanel',{attrs:{"links":_vm.iconLinks}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }